export default "__VITE_ASSET__DRm4227f__"